export default __webpack_public_path__ + "static/media/edit-pen.03506d1a.svg";